import { HeaderTabsComponent } from './../../components/_header-dropdowns/header-tabs/header-tabs.component';
import { WorkflowService } from '../../services/workflow.service';
import { NavVerticalService } from '../../services/nav-vetical.service';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, icons } from 'lucide-angular';

// Components
import { WpButtonComponent } from '../../components/_common/wp-button/wp-button.component';
import { LinkComponent } from '../../components/_common/link/link.component';
import { LinkIconComponent } from '../../components/_common/link-icon/link-icon.component';
import { IconComponent } from '../../components/_common/icon/icon.component';
import { ContentViewerComponent } from 'app/components/_common/content-viewer/content-viewer';
import { ClickThrottleDirective } from 'app/directives/click-throttle.directive';
import { ApiCollectionComponent } from 'app/components/_common/api-collection/api-collection.component';
import { PillComponent } from 'app/components/_common/pill/pill.component';
import { PillCountryComponent } from 'app/components/_common/pill-country/pill-country.component';
import { TabBlockComponent } from 'app/components/_common/tab-block/tab-block.component';
import { TabBlockItemComponent } from 'app/components/_common/tab-block-item/tab-block-item.component';
import { LoaderComponent } from 'app/components/_common/loader/loader.component';
import { BreadcrumbsComponent } from 'app/components/_common/breadcrumbs/breadcrumbs.component';
import { CardBasicComponent } from 'app/components/_cards/card-basic/card-basic.component';
import { WpTableComponent } from 'app/components/wp-table/wp-table.component';
import { SectionCollapsableComponent } from 'app/components/_common/section-collapsable/section-collapsable.component';
import { CardCapabilityComponent } from 'app/components/_cards/card-capability/card-capability.component';
import { SectionCollapsableParentComponent } from 'app/components/_common/section-collapsable-parent/section-collapsable-parent.component';
import { AccordionComponent } from 'app/components/accordion/accordion.component';
import { AccordionBrandedComponent } from 'app/components/accordion-branded/accordion-branded.component';
import { NavVerticalComponent } from 'app/components/_common/nav-vertical/nav-vertical.component';
import { NavVerticalUpdatedComponent } from 'app/components/_common/nav-vertical-updated/nav-vertical-updated.component';
import { LeftNavComponent } from 'app/components/_common/left-nav/left-nav.component';
import { WorkflowCardConvergenceComponent } from 'app/components/_common/workflow-card-convergence/workflow-card-convergence.component';
import { WorkflowSetupCardComponent } from 'app/components/_common/workflow-setup-card/workflow-setup-card.component';
import { WorkflowComponent } from 'app/components/_common/workflow/workflow.component';
import { WorkflowSetupComponent } from 'app/components/_common/workflow-setup/workflow-setup.component';
import { WorkflowTaskConvergenceComponent } from 'app/components/_common/workflow-task-convergence/workflow-task-convergence.component';
import { DropdownComponent } from '../../components/_common/dropdown/dropdown.component';
import { DropdownConvergenceComponent } from '../../components/_common/dropdown-convergence/dropdown-convergence.component';
import { MultiSelectDropdownComponent } from '../../components/_common/multi-select-dropdown/multi-select-dropdown.component';
import { ModalComponent } from '../../components/_common/modal/modal.component';
import { GuidedModalComponent } from '../../components/_common/guided-modal/guided-modal.component';
import { WpButtonIconComponent } from '../../components/wp-button-icon/wp-button-icon.component';
import { MastheadComponent } from '../../components/masthead/masthead.component';
import { NotificationsComponent } from '../../components/notifications/notifications.component';
import { GridComponent } from '../../components/grid/grid.component';
import { GridColumnComponent } from '../../components/grid-column/grid-column.component';
import { MastheadCTAComponent } from '../../components/masthead-cta/masthead-cta.component';
import { CardAPIComponent } from '../../components/_cards/card-api/card-api.component';
import { CardProductComponent } from '../../components/_cards/card-product/card-product.component';
import { CardContactComponent } from 'app/components/_cards/card-contact/card-contact.component';
import { RelatedArticlesCardComponent } from '../../components/_cards/related-articles-card/related-articles-card.component';
import { CardSupportComponent } from '../../components/_cards/card-support/card-support.component';
import { RestVerbBoxComponent } from '../../components/_common/rest-verb-box/rest-verb-box.component';
import { TooltipComponent } from 'app/components/_common/tooltip/tooltip.component';
import { FooterComponent } from 'app/includes/footer/footer.component';
import { FooterRebrandedComponent } from 'app/includes/footer-rebranded/footer-rebranded.component';
import { SpecFooterComponent } from 'app/includes/footer/spec-footer/spec-footer.component';
import { HeaderComponent } from 'app/includes/header/header.component';
import { GlobalHeaderComponent } from 'app/includes/global-header/global-header.component';
import { CodeBlockItemComponent } from 'app/components/code-block-item/code-block-item.component';
import { CodeBlockComponent } from 'app/components/code-block/code-block.component';
import { DiagramConvergenceComponent } from 'app/components/diagram-convergence/diagram-convergence.component';
import { FileService } from 'app/services/file.service';
import { FunctionalNavComponent } from 'app/includes/functional-nav/functional-nav.component';
import { MainNavComponent } from 'app/includes/main-nav/main-nav.component';
import { HeaderNavComponent } from 'app/includes/header-nav/header-nav.component';
import { NavContainerComponent } from 'app/includes/nav-container/nav-container.component';
import { SearchBoxComponent } from 'app/includes/search-box/search-box.component';
import { SearchPagerComponent } from 'app/includes/search-pager/search-pager.component';
import { SearchViewComponent } from 'app/includes/search-view/search-view.component';
import { SearchWindowComponent } from 'app/includes/search-window/search-window.component';
import { SearchService } from 'app/services/search.service';
import { KeyboardService } from 'app/services/keyboard.service';
import { CodeblockService } from 'app/services/codeblock.service';
import { SessionService } from 'app/services/session.service';
import { PendoService } from 'app/services/pendo.service';
import { ModalMatchService } from 'app/services/modal-match.service';
import { AccountDropdownComponent } from 'app/components/_header-dropdowns/header-account-dropdown/account-dropdown.component';
import { UserAccountDropdownComponent } from 'app/components/_header-dropdowns/user-account-dropdown/user-account-dropdown.component';
import { MenuDropdownComponent } from 'app/components/_header-dropdowns/menu-dropdown/menu-dropdown.component';
import { TokenService } from 'app/services/token.service';
import { BackToTopComponent } from 'app/components/back-to-top/back-to-top.component';
import { CardComponent } from 'app/components/_cards/card/card.component';
import { SecondaryMastheadComponent } from 'app/components/secondary-masthead/secondary-masthead.component';
import { MastheadSecondaryComponent } from 'app/components/masthead-secondary/masthead-secondary.component';
import { MastheadHomepageComponent } from 'app/components/masthead-homepage/masthead-homepage.component';
import { MastheadOverlayComponent } from 'app/components/masthead-overlay/masthead-overlay.component';
import { SmallIconTileComponent } from 'app/components/_common/small-icon-tile/small-icon-tile.component';
import { CarouselComponent } from 'app/components/_common/carousel/carousel.component';
import { SmallCardComponent } from 'app/components/_cards/small-card/small-card.component';
import { ArticleCardComponent } from 'app/components/_cards/article-card/article-card.component';
import { ArticleCardListComponent } from 'app/components/article-list/article-card-list.component';
import { MastheadGradientComponent } from 'app/components/masthead-gradient/masthead-gradient.component';
import { MastheadBasicComponent } from 'app/components/masthead-basic/masthead-basic.component';
import { MastheadBasicUpdatedComponent } from 'app/components/masthead-basic-updated/masthead-basic-updated.component';
import { TestimonialRebrandingComponent } from 'app/components/testimonial-rebranding/testimonial-rebranding.component';
import { ToggleSlideComponent } from 'app/components/toggle-slide/toggle-slide.component';
import { SiteLogoComponent } from 'app/components/site-logo/site-logo.component';
import { DocIndexComponent } from 'app/components/doc-index/doc-index.component';
import { ContactBlockComponent } from 'app/components/contact-block/contact-block.component';
import { IndexComponent } from 'app/components/index/index.component';
import { HeaderMenuDropdownComponent } from 'app/components/_header-dropdowns/header-menu-dropdown/header-menu-dropdown.component';
import { HeaderNavDropdownComponent } from 'app/components/_header-dropdowns/header-nav-dropdown/header-nav-dropdown.component';
import { BaseCardComponent } from 'app/components/_cards/base-card/base-card.component';
import { ReferenceCardComponent } from 'app/components/_cards/reference-card/reference-card.component';
import { InfoCardComponent } from 'app/components/_cards/info-card/info-card.component';
import { DocheaderSecondaryNavComponent } from 'app/components/docheader-secondary-nav/docheader-secondary-nav.component';
import { WorkflowCardComponent } from 'app/components/_common/workflow-card/workflow-card.component';
import { WorkflowTaskComponent } from 'app/components/_common/workflow-task/workflow-task.component';
import { DiagramComponent } from 'app/components/diagram/diagram.component';
import { APIVersionsConvergenceComponent } from 'app/components/_common/api-versions-convergence/api-versions-convergence.component';
import { AccordionConvergenceNewComponent } from 'app/components/accordion-convergence-new/accordionConvergence.component';
import { AppAccordionConvergenceNewComponent } from 'app/components/app-accordion-convergence-new/app-accordionConvergence.component';
import { ClickOutsideDirective } from 'app/directives/clickoutside-dropdown.directive';
import { SmallScreenModalComponent } from 'app/components/small-screen-modal/small-screen-modal.component';
import { MastheadArticleComponent } from 'app/components/masthead-article/masthead-article.component';
import { CardProductUpdatedComponent } from 'app/components/_cards/card-product-updated/card-product-updated.component';
import { CardProductCategoryComponent } from 'app/components/_cards/card-product-category/card-product-category.component';
import { CardCategoryProductComponent } from 'app/components/_cards/card-category-product/card-category-product.component';
import { CardProductSmallComponent } from 'app/components/_cards/card-product-small/card-product-small.component';
import { MastheadGradientUpdatedComponent } from 'app/components/masthead-gradient-updated/masthead-gradient-updated.component';
import { VersionPillComponent } from 'app/components/_common/version-pill/version-pill.component';
import { MenuItemCardComponent } from 'app/components/_cards/menu-item-card/menu-item-card.component';
import { ProdMenuComponent } from 'app/templates/prod-menu/prod-menu.component';
import { SolutionMenuComponent } from 'app/templates/solution-menu/solution-menu.component';
import { SideBarComponent } from 'app/components/_common/sidebar/sidebar.component';

import { ResourceMenuComponent } from 'app/templates/resource-menu/resource-menu.component';
import { PublicComponent } from 'app/templates/public/public.component';
import { PillContainerComponent } from 'app/components/_common/pill-container/pill-container.component';
import { ContentTagComponent } from 'app/components/_common/content-tag/content-tag.component';
import { SearchTooltipComponent } from 'app/components/_common/search-tooltip/search-tooltip.component';
import { SolutionFinderCardComponent } from 'app/components/_cards/solution-finder-card/solution-finder-card.component';

import { FilterComponent } from 'app/components/_common/filter/filter.component';
import { FilterComboBoxComponent } from 'app/components/_common/filter-combo-box/filter-combo-box.component';
import { SearchCardComponent } from 'app/components/_common/search-card/search-card.component';
import { DevsiteSearchComponent } from '../../components/devsite-search/devsite-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalSearchComponent } from 'app/components/local-search/local-search.component';
import { CategorySidebarComponent } from 'app/components/_common/category-sidebar/category-sidebar.component';
import { MarketplaceCardComponent } from 'app/components/_common/marketplace-card/marketplace-card.component';
import { InlineAlertBannerComponent } from 'app/components/inline-alert-banner/inline-alert-banner.component';
import { IndicatorChipWrapperComponent } from 'app/components/_common/indicator-chip-wrapper/indicator-chip-wrapper.component';
import { LLMActionsComponent } from 'app/components/_common/llm-actions/llm-actions.component';
import { WpCell, WpChips, WpComboBox, WpFlag, WpHeaderCell, WpHeaderRow, WpIcon, WpInlineBanner, WpNav, WpRadio, WpRow, WpSkeleton, WpTable } from '@wp-webcomponent/angular-ui-core';
import { ContactBlockBannerComponent } from 'app/components/contact-block-banner/contact-block-banner.component';
import { WpNotificationsComponent } from 'app/components/wp-notifications/wp-notifications.component';
import { AppSidebarComponent } from 'app/components/_common/app-sidebar/app-sidebar.component';
import { AppNavVerticalUpdatedComponent } from 'app/components/_common/app-nav-vertical-updated/app-nav-vertical-updated.component';
import { AppWorkflowCardConvergenceComponent } from 'app/components/_common/app-workflow-card-convergence/app-workflow-card-convergence.component';
import { LeftNavSkeletonComponent } from 'app/components/_common/left-nav-skeleton/left-nav-skeleton.component';
import { DocheaderSecondaryNavSkeletonComponent } from 'app/components/docheader-secondary-nav-skeleton/docheader-secondary-nav-skeleton.component';
import { GlobalHeaderSkeletonComponent } from 'app/components/_common/global-header-skeleton/global-header-skeleton.component';

@NgModule({
  declarations: [
    LLMActionsComponent,
    MarketplaceCardComponent,
    LocalSearchComponent,
    VersionPillComponent,
    IndicatorChipWrapperComponent,
    ContentTagComponent,
    SearchTooltipComponent,
    FilterComponent,
    FilterComboBoxComponent,
    PublicComponent,
    ContentViewerComponent,
    LinkComponent,
    LinkIconComponent,
    IconComponent,
    WpButtonComponent,
    ClickThrottleDirective,
    ClickOutsideDirective,
    ApiCollectionComponent,
    CardAPIComponent,
    PillComponent,
    PillCountryComponent,
    PillContainerComponent,
    TabBlockComponent,
    TabBlockItemComponent,
    LoaderComponent,
    MastheadCTAComponent,
    GridColumnComponent,
    MastheadArticleComponent,
    GridComponent,
    NotificationsComponent,
    WpNotificationsComponent,
    MastheadComponent,
    MastheadGradientComponent,
    MastheadGradientUpdatedComponent,
    MastheadBasicComponent,
    MastheadBasicUpdatedComponent,
    WpButtonIconComponent,
    RelatedArticlesCardComponent,
    BreadcrumbsComponent,
    CardBasicComponent,
    CardProductComponent,
    CardContactComponent,
    RelatedArticlesCardComponent,
    CardSupportComponent,
    CardProductUpdatedComponent,
    CardProductCategoryComponent,
    CardCategoryProductComponent,
    CardProductSmallComponent,
    SectionCollapsableComponent,
    WpTableComponent,
    ModalComponent,
    GuidedModalComponent,
    CardCapabilityComponent,
    SectionCollapsableParentComponent,
    AccordionComponent,
    AccordionBrandedComponent,
    NavVerticalComponent,
    NavVerticalUpdatedComponent,
    AppNavVerticalUpdatedComponent,
    LeftNavComponent,
    DropdownComponent,
    DropdownConvergenceComponent,
    MultiSelectDropdownComponent,
    WorkflowCardConvergenceComponent,
    AppWorkflowCardConvergenceComponent,
    WorkflowSetupCardComponent,
    WorkflowComponent,
    WorkflowSetupComponent,
    WorkflowTaskConvergenceComponent,
    RestVerbBoxComponent,
    TooltipComponent,
    FooterComponent,
    SpecFooterComponent,
    FooterRebrandedComponent,
    HeaderComponent,
    GlobalHeaderComponent,
    CodeBlockComponent,
    CodeBlockItemComponent,
    DiagramConvergenceComponent,
    MainNavComponent,
    HeaderNavComponent,
    NavContainerComponent,
    FunctionalNavComponent,
    SearchBoxComponent,
    SearchWindowComponent,
    SearchViewComponent,
    SearchPagerComponent,
    AccountDropdownComponent,
    UserAccountDropdownComponent,
    MenuDropdownComponent,
    BackToTopComponent,
    CardComponent,
    SecondaryMastheadComponent,
    MastheadSecondaryComponent,
    MastheadHomepageComponent,
    MastheadOverlayComponent,
    SmallIconTileComponent,
    CarouselComponent,
    SmallCardComponent,
    ArticleCardComponent,
    ArticleCardListComponent,
    MenuItemCardComponent,
    ProdMenuComponent,
    SolutionMenuComponent,
    ResourceMenuComponent,
    TestimonialRebrandingComponent,
    ToggleSlideComponent,
    SiteLogoComponent,
    BaseCardComponent,
    ReferenceCardComponent,
    InfoCardComponent,
    DocIndexComponent,
    ContactBlockComponent,
    IndexComponent,
    HeaderMenuDropdownComponent,
    HeaderNavDropdownComponent,
    HeaderTabsComponent,
    DocheaderSecondaryNavComponent,
    DocheaderSecondaryNavSkeletonComponent,
    WorkflowCardComponent,
    WorkflowTaskComponent,
    DiagramComponent,
    APIVersionsConvergenceComponent,
    SmallScreenModalComponent,
    AccordionConvergenceNewComponent,
    AppAccordionConvergenceNewComponent,
    SideBarComponent,
    LeftNavSkeletonComponent,
    GlobalHeaderSkeletonComponent,
    AppSidebarComponent,
    SolutionFinderCardComponent,
    SearchCardComponent,
    DevsiteSearchComponent,
    MarketplaceCardComponent,
    CategorySidebarComponent,
    InlineAlertBannerComponent,
    ContactBlockBannerComponent
  ],
  imports: [CommonModule, RouterModule, LucideAngularModule.pick(icons), ReactiveFormsModule, FormsModule, WpInlineBanner, WpIcon, WpRadio, WpTable, WpHeaderCell, WpHeaderRow, WpCell, WpRow, WpNav, WpComboBox, WpFlag, WpChips, WpSkeleton],
  exports: [
    LLMActionsComponent,
    MarketplaceCardComponent,
    LocalSearchComponent,
    VersionPillComponent,
    IndicatorChipWrapperComponent,
    ContentTagComponent,
    SearchTooltipComponent,
    FilterComponent,
    FilterComboBoxComponent,
    PublicComponent,
    ContentViewerComponent,
    LinkComponent,
    IconComponent,
    LinkIconComponent,
    WpButtonComponent,
    ClickThrottleDirective,
    ClickOutsideDirective,
    ApiCollectionComponent,
    CardAPIComponent,
    MastheadArticleComponent,
    PillComponent,
    PillCountryComponent,
    PillContainerComponent,
    TabBlockComponent,
    TabBlockItemComponent,
    DocheaderSecondaryNavSkeletonComponent,
    LoaderComponent,
    MastheadCTAComponent,
    MastheadGradientComponent,
    MastheadGradientUpdatedComponent,
    MastheadBasicComponent,
    RelatedArticlesCardComponent,
    MastheadBasicUpdatedComponent,
    GridColumnComponent,
    GridComponent,
    NotificationsComponent,
    WpNotificationsComponent,
    MastheadComponent,
    WpButtonIconComponent,
    BreadcrumbsComponent,
    CardBasicComponent,
    CardProductComponent,
    CardContactComponent,
    RelatedArticlesCardComponent,
    CardSupportComponent,
    CardProductUpdatedComponent,
    CardProductCategoryComponent,
    CardCategoryProductComponent,
    CardProductSmallComponent,
    SectionCollapsableComponent,
    WpTableComponent,
    ModalComponent,
    GuidedModalComponent,
    CardCapabilityComponent,
    SectionCollapsableParentComponent,
    AccordionComponent,
    AccordionBrandedComponent,
    AccordionConvergenceNewComponent,
    AppAccordionConvergenceNewComponent,
    NavVerticalComponent,
    NavVerticalUpdatedComponent,
    AppNavVerticalUpdatedComponent,
    LeftNavComponent,
    DropdownComponent,
    DropdownConvergenceComponent,
    MultiSelectDropdownComponent,
    WorkflowCardConvergenceComponent,
    AppWorkflowCardConvergenceComponent,
    WorkflowSetupCardComponent,
    WorkflowComponent,
    WorkflowSetupComponent,
    WorkflowTaskConvergenceComponent,
    WorkflowCardComponent,
    WorkflowTaskComponent,
    RestVerbBoxComponent,
    TooltipComponent,
    FooterComponent,
    SpecFooterComponent,
    FooterRebrandedComponent,
    HeaderComponent,
    GlobalHeaderComponent,
    CodeBlockComponent,
    CodeBlockItemComponent,
    DiagramConvergenceComponent,
    MainNavComponent,
    HeaderNavComponent,
    NavContainerComponent,
    FunctionalNavComponent,
    AccountDropdownComponent,
    UserAccountDropdownComponent,
    MenuDropdownComponent,
    SearchWindowComponent,
    SearchBoxComponent,
    SearchViewComponent,
    SearchPagerComponent,
    BackToTopComponent,
    CardComponent,
    SecondaryMastheadComponent,
    MastheadSecondaryComponent,
    MastheadHomepageComponent,
    MastheadOverlayComponent,
    SmallIconTileComponent,
    CarouselComponent,
    SmallCardComponent,
    ArticleCardComponent,
    ArticleCardListComponent,
    MenuItemCardComponent,
    ProdMenuComponent,
    SolutionMenuComponent,
    ResourceMenuComponent,
    TestimonialRebrandingComponent,
    ToggleSlideComponent,
    SiteLogoComponent,
    DocIndexComponent,
    ContactBlockComponent,
    IndexComponent,
    HeaderMenuDropdownComponent,
    HeaderNavDropdownComponent,
    HeaderTabsComponent,
    BaseCardComponent,
    ReferenceCardComponent,
    InfoCardComponent,
    DocheaderSecondaryNavComponent,
    DiagramComponent,
    APIVersionsConvergenceComponent,
    SmallScreenModalComponent,
    SideBarComponent,
    LeftNavSkeletonComponent,
    GlobalHeaderSkeletonComponent,
    AppSidebarComponent,
    LucideAngularModule,
    SolutionFinderCardComponent,
    SearchCardComponent,
    DevsiteSearchComponent,
    MarketplaceCardComponent,
    CategorySidebarComponent,
    InlineAlertBannerComponent,
    ContactBlockBannerComponent,
    WpInlineBanner,
    WpIcon,
    WpRadio,
    WpTable,
    WpHeaderCell,
    WpHeaderRow,
    WpCell,
    WpRow,
    WpNav,
    WpFlag,
    WpChips,
    WpSkeleton
  ],
  providers: [
    NavVerticalService,
    WorkflowService,
    FileService,
    SearchService,
    CodeblockService,
    SessionService,
    PendoService,
    ModalMatchService,
    TokenService,
    KeyboardService,
  ],
})
export class SharedModule {}
